export default "__VITE_ASSET__0cc54be3__"